import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { getCustomTable, saveCustomTable, publishCustomTable } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Cấu hình cột mặc định cho từng bảng. columns: [{key,label,width}].
const c = (key, label, width = 130) => ({ key, label, width });
export const TABLE_CONFIG = {
  bus: {
    title: "Ô tô đưa đón", icon: "🚌",
    columns: [c("tuyen", "Tuyến", 90), c("bienso", "Biển số xe", 110), c("taixe", "Tài xế", 140), c("sdt", "SĐT tài xế", 110), c("diemdon", "Điểm đón", 160), c("giodon", "Giờ đón", 90), c("sohs", "Số HS", 70), c("phi", "Phí/tháng", 100), c("ghichu", "Ghi chú", 160)],
  },
  meals: {
    title: "Ăn bán trú", icon: "🍚",
    columns: [c("lop", "Lớp", 80), c("sosuat", "Số suất", 80), c("loaisuat", "Loại suất", 110), c("dongia", "Đơn giá", 100), c("ngay", "Ngày áp dụng", 120), c("ghichu", "Ghi chú", 180)],
  },
  parent: {
    title: "Cha mẹ đồng hành cùng học sinh", icon: "👪",
    columns: [c("phuhuynh", "Họ tên phụ huynh", 160), c("sdt", "SĐT", 110), c("con", "Con (học sinh)", 150), c("lop", "Lớp", 80), c("hinhthuc", "Hình thức đồng hành", 180), c("thoigian", "Thời gian", 120), c("ghichu", "Ghi chú", 160)],
  },
  admission10: {
    title: "Tuyển sinh học sinh khối 10", icon: "🎓",
    columns: [c("hoten", "Họ và tên", 160), c("ngaysinh", "Ngày sinh", 110), c("gioitinh", "Giới tính", 90), c("sdtph", "SĐT phụ huynh", 120), c("truongc2", "Trường cấp 2", 160), c("diem", "Điểm/Nguyện vọng", 130), c("tohop", "Tổ hợp đăng ký", 130), c("trangthai", "Trạng thái", 120), c("ghichu", "Ghi chú", 150)],
  },
  recruitment: {
    title: "Tuyển dụng", icon: "💼",
    columns: [c("hoten", "Họ và tên", 160), c("vitri", "Vị trí", 140), c("bomon", "Bộ môn/Phòng ban", 150), c("sdt", "SĐT", 110), c("email", "Email", 160), c("trinhdo", "Trình độ", 120), c("trangthai", "Trạng thái", 120), c("ngaynop", "Ngày nộp", 110), c("ghichu", "Ghi chú", 150)],
  },
  teacherEval: {
    title: "Đánh giá giáo viên", icon: "⭐",
    columns: [c("giaovien", "Giáo viên", 160), c("bomon", "Bộ môn", 120), c("kydanhgia", "Kỳ đánh giá", 120), c("chuyenmon", "Chuyên môn", 110), c("tinhthan", "Tinh thần", 110), c("hocsinh", "HS đánh giá", 110), c("xeploai", "Xếp loại", 110), c("nhanxet", "Nhận xét", 200)],
  },

  // ----- Nhóm DANH SÁCH HỌC SINH -----
  hssvK12: { group: "student", title: "HSSV Đã ra trường", icon: "🧑‍🎓", route: "/happyschool/hssv-k12",
    columns: [c("hoten", "Họ và tên", 170), c("namhoc", "Năm học/Khoá", 110), c("lop", "Lớp", 80), c("ngaysinh", "Ngày sinh", 110), c("gioitinh", "Giới tính", 80), c("diachi", "Địa chỉ", 200), c("sdtph", "SĐT phụ huynh", 120), c("trangthai", "Trạng thái", 120), c("ghichu", "Ghi chú", 150)] },
  // 3 danh sách con — hiển thị theo từng năm học trong tree "HSSV khối 12 các năm" (không đứng riêng ở hub).
  hssvTotNghiep: { title: "HSSV đã được cấp bằng TN", icon: "🎓",
    columns: [c("hoten", "Họ và tên", 170), c("khoa", "Khoá/Lớp", 100), c("ngaysinh", "Ngày sinh", 110), c("sobang", "Số bằng", 120), c("ngaycap", "Ngày cấp", 110), c("xeploai", "Xếp loại", 100), c("ghichu", "Ghi chú", 150)] },
  bangDiemTN: { title: "Bảng điểm HSSV đã tốt nghiệp", icon: "📊",
    columns: [c("hoten", "Họ và tên", 170), c("khoa", "Khoá/Lớp", 100), c("diemtb", "Điểm TB", 90), c("xeploai", "Xếp loại", 100), c("hanhkiem", "Hạnh kiểm", 100), c("ghichu", "Ghi chú", 170)] },
  hssvUuTu: { title: "HSSV ưu tú", icon: "🏆",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("thanhtich", "Thành tích", 220), c("ghichu", "Ghi chú", 150)] },
  hssvToanKhoi12: { title: "Học sinh Toàn Khối 12", icon: "📋",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("gioitinh", "Giới tính", 80), c("ngaysinh", "Ngày sinh", 110), c("truong", "Trường ĐH/CĐ (nếu có)", 200), c("diem", "Điểm trúng tuyển", 120), c("dienDiLam", "Diện đi làm ngay", 140), c("ghichu", "Ghi chú", 150)] },
  // 2 danh sách này KHÔNG lưu dữ liệu riêng — chỉ là bộ lọc hiển thị (read-only)
  // trên chính bảng "hssvToanKhoi12" cùng năm, để tránh trùng lặp/lệch dữ liệu
  // khi sửa ở bảng gốc. Xem HappySchoolFilteredView + HappySchoolYearTree.
  hssvDoCDDH: { title: "Đỗ cao đẳng, đại học", icon: "🏫",
    filterOf: "hssvToanKhoi12", predicate: (r) => !!String(r.truong || "").trim() },
  hssvDiLamNgay: { title: "Đi làm ngay", icon: "💼",
    filterOf: "hssvToanKhoi12", predicate: (r) => !!String(r.dienDiLam || "").trim() },
  // Nhóm gộp 3 danh sách hoàn cảnh/chính sách — tree theo năm (không đứng riêng ở hub).
  nhomHoanCanh: { group: "student", title: "HSSV Thuộc diện hoàn cảnh, chính sách", icon: "🤲",
    route: "/happyschool/nhom-hoan-canh" },
  hssvHoNgheo: { title: "HSSV hộ nghèo, cận nghèo", icon: "🏠",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("dien", "Diện (nghèo/cận nghèo)", 150), c("mahho", "Mã hộ", 120), c("diachi", "Địa chỉ", 200), c("ghichu", "Ghi chú", 150)] },
  hssvNeoDon: { title: "HSSV neo đơn, đặc biệt khó khăn", icon: "💗",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("hoancanh", "Hoàn cảnh", 240), c("ghichu", "Ghi chú", 150)] },
  hssvHoTro: { title: "HSSV diện khó khăn cần NT hỗ trợ", icon: "🤝",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("hoancanh", "Hoàn cảnh", 200), c("hinhthuc", "Hình thức hỗ trợ", 180), c("ghichu", "Ghi chú", 150)] },
  hssvThucTap: { group: "student", title: "HSSV ý thức chưa tốt khi thực tập", icon: "⚠️",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("dot", "Đợt thực tập", 130), c("vande", "Vấn đề", 220), c("ghichu", "Ghi chú", 150)] },
  hssvHKTot: { group: "student", title: "HSSV hạnh kiểm tốt, học lực khá giỏi", icon: "🌟",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("hanhkiem", "Hạnh kiểm", 100), c("hoclc", "Học lực", 100), c("ghichu", "Ghi chú", 170)] },
  hssvHKBoSung: { group: "student", title: "HSSV hạnh kiểm cần giáo dục bổ sung", icon: "🔔",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("vande", "Vấn đề", 220), c("bienphap", "Biện pháp", 200), c("ghichu", "Ghi chú", 150)] },
  hssvXuatNgoai: { group: "student", title: "HSSV sang nước phát triển làm việc", icon: "✈️",
    columns: [c("hoten", "Họ và tên", 170), c("khoa", "Khoá/Lớp", 100), c("nuoc", "Nước đến", 110), c("nganh", "Ngành/Công việc", 160), c("thoigian", "Thời gian", 120), c("ghichu", "Ghi chú", 150)] },
  hssvTruotTN: { title: "HS trượt TN THPT QG", icon: "❗",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("monTruot", "Môn/điểm chưa đạt", 180), c("nguyennhan", "Nguyên nhân", 180), c("ghichu", "Ghi chú", 150)] },
  hssvSucKhoe: { group: "student", title: "Kết quả sức khỏe HSSV", icon: "🩺",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("chieucao", "Chiều cao", 90), c("cannang", "Cân nặng", 90), c("nhommau", "Nhóm máu", 90), c("tinhtrang", "Tình trạng SK", 160), c("ghichu", "Ghi chú", 150)] },
  quanSinh: { group: "student", title: "Dữ liệu quản sinh", icon: "📋",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("ngay", "Ngày", 110), c("noidung", "Nội dung (vi phạm/khen)", 220), c("xuly", "Xử lý", 160), c("ghichu", "Ghi chú", 150)] },
  dongPhuc: { group: "student", title: "Số đo đồng phục toàn trường", icon: "👕",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("chieucao", "Chiều cao", 90), c("cannang", "Cân nặng", 90), c("sizeao", "Size áo", 80), c("sizequan", "Size quần", 80), c("ghichu", "Ghi chú", 130)] },
  muaSGK: { group: "student", title: "Danh sách mua SGK, vở viết", icon: "📚",
    columns: [c("hoten", "Họ và tên", 170), c("lop", "Lớp", 80), c("bosgk", "Bộ SGK", 120), c("sovo", "Số vở", 80), c("thanhtien", "Thành tiền", 110), c("danop", "Đã nộp", 90), c("ghichu", "Ghi chú", 130)] },
  phuHuynhBatThuong: { group: "student", title: "Phụ huynh có biểu hiện bất thường", icon: "🚩",
    columns: [c("hocsinh", "Học sinh", 160), c("lop", "Lớp", 80), c("phuhuynh", "Phụ huynh", 150), c("sdt", "SĐT", 110), c("bieuhien", "Biểu hiện", 220), c("ghichu", "Ghi chú", 150)] },
};

let seq = 0;
const newId = () => `r${Date.now()}_${seq++}`;

const HappySchoolDataTable = ({ tableKey: propKey, config }) => {
  const params = useParams();
  const tableKey = propKey || params.tableKey;
  const schoolId = getActiveSchoolId();
  const cfg = config || TABLE_CONFIG[tableKey];
  const [columns, setColumns] = useState(cfg ? cfg.columns : []);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [published, setPublished] = useState(null); // {at, byUid} hoặc null
  const [publishing, setPublishing] = useState(false);

  useEffect(() => {
    if (!schoolId || !cfg) return;
    setLoading(true);
    getCustomTable(schoolId, tableKey)
      .then((d) => {
        setColumns(Array.isArray(d.columns) && d.columns.length ? d.columns : cfg.columns);
        setRows(Array.isArray(d.rows) ? d.rows : []);
        setPublished(d.published || null);
        setDirty(false);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, [schoolId, tableKey]);

  if (!cfg) return <p style={{ padding: 16 }}>Bảng không tồn tại.</p>;
  if (!schoolId)
    return (
      <div style={{ padding: 24 }}>
        Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link> trước.
      </div>
    );

  const setCell = (rowId, key, value) => {
    setRows((rs) => rs.map((r) => (r.id === rowId ? { ...r, [key]: value } : r)));
    setDirty(true);
  };
  const addRow = () => { setRows((rs) => [...rs, { id: newId() }]); setDirty(true); };
  const delRow = (rowId) => { setRows((rs) => rs.filter((r) => r.id !== rowId)); setDirty(true); };

  const save = async () => {
    setSaving(true); setError(""); setMsg("");
    try {
      await saveCustomTable(schoolId, tableKey, { columns, rows });
      setDirty(false); setMsg("Đã lưu.");
    } catch (err) { setError(err.message); } finally { setSaving(false); }
  };

  const publish = async () => {
    if (dirty && !window.confirm("Còn thay đổi chưa lưu — lưu rồi công bố luôn?")) return;
    setPublishing(true); setError(""); setMsg("");
    try {
      if (dirty) await saveCustomTable(schoolId, tableKey, { columns, rows });
      const r = await publishCustomTable(schoolId, tableKey);
      setPublished(r.published);
      setDirty(false); setMsg("Đã công bố.");
    } catch (err) { setError(err.message); } finally { setPublishing(false); }
  };

  const exportExcel = () => {
    const aoa = [columns.map((c2) => c2.label), ...rows.map((r) => columns.map((c2) => r[c2.key] ?? ""))];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = columns.map((c2) => ({ wch: Math.max(10, Math.round((c2.width || 120) / 7)) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, cfg.title.slice(0, 28));
    XLSX.writeFile(wb, `${tableKey}.xlsx`);
  };
  const importFile = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const wb = XLSX.read(new Uint8Array(ev.target.result), { type: "array" });
        const aoa = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: "" });
        if (aoa.length < 2) { setError("File trống."); return; }
        const header = aoa[0].map((x) => String(x).trim());
        // map cột theo nhãn; nhãn không khớp thì bỏ qua
        const colByLabel = Object.fromEntries(columns.map((c2) => [c2.label, c2.key]));
        const imported = aoa.slice(1).filter((r) => r.some((x) => String(x).trim())).map((r) => {
          const obj = { id: newId() };
          header.forEach((h, i) => { const k = colByLabel[h]; if (k) obj[k] = r[i]; });
          return obj;
        });
        setRows(imported); setDirty(true); setMsg(`Đã nhập ${imported.length} dòng từ Excel.`);
      } catch (err) { setError("Lỗi đọc Excel: " + err.message); }
    };
    reader.readAsArrayBuffer(file);
    e.target.value = "";
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ margin: "0 0 4px" }}>{cfg.icon} {cfg.title}</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>Bảng dữ liệu độc lập — thêm/sửa/xoá dòng, nhập/xuất Excel. Nhớ bấm <strong>Lưu</strong>.</p>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
        <button type="button" onClick={addRow} style={btn}>+ Thêm dòng</button>
        <label style={{ ...btn2, cursor: "pointer" }}>⬆ Nhập Excel
          <input type="file" accept=".xlsx,.xls" onChange={importFile} style={{ display: "none" }} />
        </label>
        <button type="button" onClick={exportExcel} style={btn2} disabled={rows.length === 0}>⬇ Xuất Excel</button>
        <span style={{ marginLeft: "auto", fontSize: 13, color: "#6b7280" }}>{rows.length} dòng</span>
        <button type="button" onClick={save} disabled={saving || !dirty} style={{ ...btn, background: dirty ? "#0ea5a3" : "#9ca3af" }}>
          {saving ? "Đang lưu..." : dirty ? "💾 Lưu thay đổi" : "Đã lưu"}
        </button>
        {cfg.publishable && (
          <button type="button" onClick={publish} disabled={publishing} style={{ ...btn, background: "#7c3aed" }}>
            {publishing ? "Đang công bố..." : "📢 Công bố"}
          </button>
        )}
      </div>
      {cfg.publishable && published && (
        <p style={{ color: "#7c3aed", fontSize: 12, marginTop: -6 }}>
          Đã công bố lúc {new Date(published.at).toLocaleString("vi-VN")}
        </p>
      )}
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {msg && <p style={{ color: "#059669" }}>{msg}</p>}

      {loading ? (
        <p>Đang tải...</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={{ ...th, width: 44 }}>#</th>
                {columns.map((col) => (<th key={col.key} style={{ ...th, minWidth: col.width }}>{col.label}</th>))}
                <th style={{ ...th, width: 50 }}></th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr><td colSpan={columns.length + 2} style={{ ...td, textAlign: "center", color: "#9ca3af", padding: 20 }}>Chưa có dòng nào — bấm "+ Thêm dòng" hoặc "Nhập Excel".</td></tr>
              ) : rows.map((r, i) => (
                <tr key={r.id}>
                  <td style={{ ...td, textAlign: "center", color: "#9ca3af" }}>{i + 1}</td>
                  {columns.map((col) => (
                    <td key={col.key} style={td}>
                      <input value={r[col.key] ?? ""} onChange={(e) => setCell(r.id, col.key, e.target.value)}
                        style={{ width: "100%", border: "none", outline: "none", fontSize: 13, background: "transparent", padding: "2px 0" }} />
                    </td>
                  ))}
                  <td style={{ ...td, textAlign: "center" }}>
                    <button type="button" onClick={() => delRow(r.id)} title="Xoá dòng" style={{ border: "none", background: "transparent", color: "#dc2626", cursor: "pointer", fontSize: 15 }}>✕</button>
                  </td>
                </tr>
              ))}
              {Array.isArray(cfg.totalColumns) && cfg.totalColumns.length > 0 && rows.length > 0 && (
                <tr style={{ background: "#f9fafb", fontWeight: 700 }}>
                  <td style={td}></td>
                  {columns.map((col, i) => {
                    if (cfg.totalColumns.includes(col.key)) {
                      const sum = rows.reduce((s, r) => s + (Number(r[col.key]) || 0), 0);
                      return (<td key={col.key} style={td}>{sum.toLocaleString("vi-VN")}</td>);
                    }
                    // Nhãn "Tổng cộng" ở cột chữ ĐẦU TIÊN không nằm trong totalColumns.
                    const isFirstLabelCol = i === columns.findIndex((c2) => !cfg.totalColumns.includes(c2.key));
                    return (<td key={col.key} style={td}>{isFirstLabelCol ? "Tổng cộng" : ""}</td>);
                  })}
                  <td style={td}></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const btn = { padding: "8px 14px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const btn2 = { padding: "8px 14px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const th = { border: "1px solid #e5e7eb", padding: "7px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "left", position: "sticky", top: 0 };
const td = { border: "1px solid #e5e7eb", padding: "4px 8px" };

export default HappySchoolDataTable;
